import React from 'react';
import CGamePage from './CGamePage';
import ChessPage from './ChessPage';

const CChess = () => <CGamePage gameKey="chess" title="Chess" page={ChessPage} />;

export default CChess;
